/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_Drop_Frame_TimecodeInputs */

const en_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable drop frame timecode`)
};

const fr_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le timecode drop frame`)
};

const de_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-Frame-Timecode aktivieren`)
};

const it_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita il timecode drop frame`)
};

const ru_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить временной код пропуска кадра`)
};

const es_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar el código de tiempo de eliminación de fotogramas`)
};

const zh_cn2_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用丢帧时间码`)
};

const ja_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレームタイムコードを有効にする`)
};

const hi_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम टाइमकोड सक्षम करें`)
};

const pt_pt2_enable_drop_frame_timecode = /** @type {(inputs: Enable_Drop_Frame_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar código de tempo de quadro solto`)
};

/**
* | output |
* | --- |
* | "Enable drop frame timecode" |
*
* @param {Enable_Drop_Frame_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_drop_frame_timecode = /** @type {((inputs?: Enable_Drop_Frame_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Drop_Frame_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enable_drop_frame_timecode(inputs)
	if (locale === "de") return de_enable_drop_frame_timecode(inputs)
	if (locale === "it") return it_enable_drop_frame_timecode(inputs)
	if (locale === "ru") return ru_enable_drop_frame_timecode(inputs)
	if (locale === "es") return es_enable_drop_frame_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_enable_drop_frame_timecode(inputs)
	if (locale === "ja") return ja_enable_drop_frame_timecode(inputs)
	if (locale === "hi") return hi_enable_drop_frame_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_enable_drop_frame_timecode(inputs)
	return en_enable_drop_frame_timecode(inputs)
});